<div class="contents">
    <app-back-button></app-back-button>
    <div class="page-header">
        <div class="left-area">
            <span class="title">Utilizadores</span>
            <span class="sub-title">Edite e Visualize os utilizadores</span>
        </div>

        <div class="indicator" *ngIf="totalRecords">
            <div class="indicator">
                <div class="icon">
                    <img src="icons/users-check.svg" alt="Country Icon" />
                </div>
                <div class="text-bg">
                    <span>{{totalRecords}} Utilizadores</span>
                </div>
            </div>
        </div>
    </div>

    <app-lista-users (totalRecordsChange)="onTotalRecordsChange($event)"></app-lista-users>

</div>